// Simplified Chinese for ra-core and ra-supabase. Flat "a.b.c" keys, expanded by unflattenMessages.
export const chineseRaMessagesFlat: Record<string, string> = {
  "ra.action.add_filter": "添加筛选",
  "ra.action.add": "添加",
  "ra.action.back": "返回",
  "ra.action.bulk_actions": "已选 %{smart_count} 项",
  "ra.action.cancel": "取消",
  "ra.action.clear_array_input": "清空列表",
  "ra.action.clear_input_value": "清空",
  "ra.action.clone": "复制",
  "ra.action.confirm": "确认",
  "ra.action.create": "新建",
  "ra.action.create_item": "新建 %{item}",
  "ra.action.delete": "删除",
  "ra.action.edit": "编辑",
  "ra.action.export": "导出",
  "ra.action.list": "列表",
  "ra.action.refresh": "刷新",
  "ra.action.remove_filter": "移除此筛选",
  "ra.action.remove_all_filters": "清除全部筛选",
  "ra.action.remove": "移除",
  "ra.action.reset": "重置",
  "ra.action.save": "保存",
  "ra.action.search": "搜索",
  "ra.action.search_columns": "搜索列",
  "ra.action.select_all": "全选",
  "ra.action.select_all_button": "全选",
  "ra.action.select_row": "选择此行",
  "ra.action.show": "查看",
  "ra.action.sort": "排序",
  "ra.action.undo": "撤销",
  "ra.action.unselect": "取消选择",
  "ra.action.expand": "展开",
  "ra.action.close": "关闭",
  "ra.action.open_menu": "打开菜单",
  "ra.action.close_menu": "关闭菜单",
  "ra.action.update": "更新",
  "ra.action.move_up": "上移",
  "ra.action.move_down": "下移",
  "ra.action.open": "打开",
  "ra.action.toggle_theme": "切换浅色/深色",
  "ra.action.select_columns": "列",
  "ra.action.update_application": "重新加载",
  "ra.boolean.true": "是",
  "ra.boolean.false": "否",
  "ra.page.create": "新建%{name}",
  "ra.page.dashboard": "首页",
  "ra.page.edit": "%{name} %{recordRepresentation}",
  "ra.page.error": "出错了",
  "ra.page.list": "%{name}",
  "ra.page.loading": "加载中",
  "ra.page.not_found": "页面不存在",
  "ra.page.show": "%{name} %{recordRepresentation}",
  "ra.page.empty": "还没有%{name}。",
  "ra.page.invite": "要新建一个吗？",
  "ra.page.access_denied": "无权访问",
  "ra.page.authentication_error": "登录验证出错",
  "ra.input.file.upload_several": "把文件拖到这里，或点击选择。",
  "ra.input.file.upload_single": "把文件拖到这里，或点击选择。",
  "ra.input.image.upload_several": "把图片拖到这里，或点击选择。",
  "ra.input.image.upload_single": "把图片拖到这里，或点击选择。",
  "ra.input.references.all_missing": "找不到关联数据。",
  "ra.input.references.many_missing": "部分关联数据已不存在。",
  "ra.input.references.single_missing": "关联数据已不存在。",
  "ra.input.password.toggle_visible": "隐藏密码",
  "ra.input.password.toggle_hidden": "显示密码",
  "ra.message.about": "关于",
  "ra.message.access_denied": "你没有访问此页面的权限",
  "ra.message.are_you_sure": "确定吗？",
  "ra.message.authentication_error": "登录服务器返回错误，无法验证你的账号。",
  "ra.message.auth_error": "验证登录凭证时出错。",
  "ra.message.bulk_delete_content": "确定删除这 %{smart_count} 项吗？",
  "ra.message.bulk_delete_title": "删除 %{smart_count} 项%{name}",
  "ra.message.bulk_update_content": "确定更新这 %{smart_count} 项吗？",
  "ra.message.bulk_update_title": "更新 %{smart_count} 项%{name}",
  "ra.message.clear_array_input": "确定清空整个列表吗？",
  "ra.message.delete_content": "确定删除这条%{name}吗？",
  "ra.message.delete_title": "删除%{name} %{recordRepresentation}",
  "ra.message.details": "详情",
  "ra.message.error": "页面出错，请求没有完成。",
  "ra.message.invalid_form": "表单有误，请检查标红的项",
  "ra.message.loading": "请稍候",
  "ra.message.no": "否",
  "ra.message.not_found": "网址输错了，或链接已失效。",
  "ra.message.select_all_limit_reached":
    "数据太多，无法全选。只选中了前 %{max} 项。",
  "ra.message.unsaved_changes": "有修改还没保存，确定放弃吗？",
  "ra.message.yes": "是",
  "ra.message.placeholder_data_warning": "网络问题：数据刷新失败。",
  "ra.navigation.clear_filters": "清除筛选",
  "ra.navigation.no_filtered_results": "当前筛选下没有%{name}。",
  "ra.navigation.no_results": "没有%{name}",
  "ra.navigation.no_more_results": "第 %{page} 页超出范围，请返回上一页。",
  "ra.navigation.page_out_of_boundaries": "第 %{page} 页超出范围",
  "ra.navigation.page_out_from_end": "已经是最后一页",
  "ra.navigation.page_out_from_begin": "已经是第一页",
  "ra.navigation.page_range_info": "%{offsetBegin}-%{offsetEnd}，共 %{total}",
  "ra.navigation.partial_page_range_info":
    "%{offsetBegin}-%{offsetEnd}，共超过 %{offsetEnd}",
  "ra.navigation.current_page": "第 %{page} 页",
  "ra.navigation.page": "前往第 %{page} 页",
  "ra.navigation.first": "第一页",
  "ra.navigation.last": "最后一页",
  "ra.navigation.next": "下一页",
  "ra.navigation.previous": "上一页",
  "ra.navigation.page_rows_per_page": "每页行数：",
  "ra.navigation.skip_nav": "跳到正文",
  "ra.sort.sort_by": "按%{field_lower_first}%{order}",
  "ra.sort.ASC": "升序",
  "ra.sort.DESC": "降序",
  "ra.auth.auth_check_error": "请先登录",
  "ra.auth.user_menu": "个人资料",
  "ra.auth.username": "用户名",
  "ra.auth.password": "密码",
  "ra.auth.email": "邮箱",
  "ra.auth.sign_in": "登录",
  "ra.auth.sign_in_error": "登录失败，请重试",
  "ra.auth.logout": "退出登录",
  "ra.notification.updated": "已更新 %{smart_count} 项",
  "ra.notification.created": "已创建",
  "ra.notification.deleted": "已删除 %{smart_count} 项",
  "ra.notification.bad_item": "数据有误",
  "ra.notification.item_doesnt_exist": "数据不存在",
  "ra.notification.http_error": "与服务器通信出错",
  "ra.notification.data_provider_error": "数据接口出错，详情见控制台。",
  "ra.notification.i18n_error": "无法加载该语言",
  "ra.notification.canceled": "已取消",
  "ra.notification.logged_out": "登录已过期，请重新登录。",
  "ra.notification.not_authorized": "你没有权限访问此内容。",
  "ra.notification.application_update_available": "有新版本可用。",
  "ra.notification.offline": "网络断开，无法获取数据。",
  "ra.validation.required": "必填",
  "ra.validation.minLength": "至少 %{min} 个字符",
  "ra.validation.maxLength": "最多 %{max} 个字符",
  "ra.validation.minValue": "不能小于 %{min}",
  "ra.validation.maxValue": "不能大于 %{max}",
  "ra.validation.number": "必须是数字",
  "ra.validation.email": "请输入有效邮箱",
  "ra.validation.oneOf": "必须是以下之一：%{options}",
  "ra.validation.regex": "格式不正确：%{pattern}",
  "ra.validation.unique": "不能重复",
  "ra.saved_queries.label": "已保存的查询",
  "ra.saved_queries.query_name": "查询名称",
  "ra.saved_queries.new_label": "保存当前查询...",
  "ra.saved_queries.new_dialog_title": "当前查询另存为",
  "ra.saved_queries.remove_label": "删除已保存的查询",
  "ra.saved_queries.remove_label_with_name": "删除查询“%{name}”",
  "ra.saved_queries.remove_dialog_title": "删除已保存的查询？",
  "ra.saved_queries.remove_message": "确定从已保存的查询里删除这一项吗？",
  "ra.saved_queries.help": "筛选列表后可保存这个查询",
  "ra.guesser.empty.title": "没有可显示的数据",
  "ra.guesser.empty.message": "请检查数据接口",
  "ra-supabase.auth.email": "邮箱",
  "ra-supabase.auth.confirm_password": "确认密码",
  "ra-supabase.auth.sign_in_with": "用 %{provider} 登录",
  "ra-supabase.auth.forgot_password": "忘记密码？",
  "ra-supabase.auth.reset_password": "重置密码",
  "ra-supabase.auth.password_reset": "请找管理员要一条登录链接来重置密码。",
  "ra-supabase.auth.missing_tokens": "缺少登录令牌",
  "ra-supabase.auth.back_to_login": "返回登录",
  "ra-supabase.reset_password.forgot_password": "忘记密码？",
  "ra-supabase.reset_password.forgot_password_details":
    "输入你的邮箱获取重置说明。",
  "ra-supabase.set_password.new_password": "设置你的密码",
  "ra-supabase.validation.password_mismatch": "两次输入的密码不一致",
};

export const unflattenMessages = (
  flat: Record<string, string>,
): Record<string, unknown> => {
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(flat)) {
    const parts = key.split(".");
    let node = out;
    parts.slice(0, -1).forEach((p) => {
      node[p] = (node[p] as Record<string, unknown>) ?? {};
      node = node[p] as Record<string, unknown>;
    });
    node[parts[parts.length - 1]] = value;
  }
  return out;
};
